import { render, staticRenderFns } from "./JdsAppFrame.vue?vue&type=template&id=ea55a0f8&scoped=true&"
import script from "./JdsAppFrame.vue?vue&type=script&lang=ts&"
export * from "./JdsAppFrame.vue?vue&type=script&lang=ts&"
import style0 from "./JdsAppFrame.vue?vue&type=style&index=0&id=ea55a0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea55a0f8",
  null
  
)

export default component.exports